// extracted by mini-css-extract-plugin
module.exports = {"select":"PublisherSelector_select__2gz1e"};